import React, { useContext, useEffect } from "react";
import RegisterLayout from "./RegisterLayout";
import CustomGooglePlaceSearchV2 from "../../../components/customGooglePlaceSearch/CustomGooglePlaceSearchV2";

import {
    FormProvider,
    SubmitHandler,
    useForm,
    Controller,
} from "react-hook-form";

import { crewLocationFormData } from "../../../data/formData";
import { MyContext } from "../../../context";
import { ErrorMessage } from "@hookform/error-message";

interface SetpCrewLocationProps {
    onNext: (data: any) => void;
    onPrevious: () => void;
}

const SetpCrewLocation: React.FC<SetpCrewLocationProps> = ({ onNext, onPrevious }) => {

    const { userData } = useContext(MyContext);

    const locationData = useForm({
        mode: "onChange",
        defaultValues: {
            ...crewLocationFormData(userData),
        },
    });

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = locationData;

    const onSubmit: SubmitHandler<any> = (values: any) => {
        const payload = {
            country: values.country || '',
            city: values.city || 'sydney',
            postcode: values.post_code || 2000,
            address: values.location,
            coordinates: {
                type: "Point",
                coordinates: [
                    Number(values.lat),
                    Number(values.lng),
                ],
            }
        }
        onNext(payload);
    };

    useEffect(() => {
        locationData.reset({
            city: userData?.city || "",
            country: userData?.country || "",
            lat: userData?.coordinates?.coordinates?.[0] || "",
            lng: userData?.coordinates?.coordinates?.[1] || '',
            location: userData?.address || "",
            post_code: userData?.postcode || "",
            radius: ""
        })
    }, [userData?.id])

    return (
        <RegisterLayout showLogout hideHeader>
            <FormProvider {...locationData}>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    noValidate
                    style={{
                        minHeight: "80vh",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div className="register-step">
                        <div className="register-step__heading-block">
                            <h1 className="register-step__title">
                                Where are you located?
                            </h1>
                            <p className="register-step__description">
                                Enter your address so production companies know where you are based.
                            </p>
                        </div>
                        <div className="personal-info__form">
                            <Controller
                                name="location"
                                control={control}
                                rules={{
                                    required: "Location is required",
                                }}
                                render={({ field }) => (
                                    <>
                                        <CustomGooglePlaceSearchV2
                                            onApply={(data: any) => {
                                                console.log(data, "CustomGooglePlaceSearchV2")
                                                field.onChange(data.location);
                                                setValue("city", data.city);
                                                setValue("country", data.country);
                                                setValue("lat", data.lat);
                                                setValue("lng", data.lng);
                                                setValue("post_code", data.post_code, { shouldValidate: true });
                                            }}
                                            data={locationData.getValues()}
                                            placeholder="Select Location"
                                            heading="Select Location"
                                            scrollwheel={false}
                                            needExtraData
                                            dropdownWidth={726}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="location"
                                            render={({ message }) => (
                                                <span
                                                    style={{ marginTop: "-20px" }}
                                                    className="input-field-error-text"
                                                >
                                                    {message}
                                                </span>
                                            )}
                                        />
                                    </>
                                )}
                            />
                        </div>
                    </div>
                    <div style={{
                        marginTop: "auto",
                    }} className="register-step__footer">
                        <button
                            className="btn-next btn-next--yellow"
                            type="button"
                            style={{ marginRight: 15 }}
                            onClick={onPrevious}
                        >
                            Previous
                        </button>
                        <button
                            className="btn-next btn-next--yellow"
                            type="submit"
                        >
                            Next
                        </button>
                    </div>
                </form>
            </FormProvider>
        </RegisterLayout>
    );
};

export default SetpCrewLocation;